import { Button, Input } from '@heroui/react';
import { SurveyLayout, MainMenuBackButton } from '@/components';
import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';
import { IconSurvey } from 'assets/icons';
import _ from 'lodash';
import { MetaInfo, Select as SelectType, TokenExtraInfo } from '@/hooks/useSurvey';
import { Fragment } from 'react/jsx-runtime';
import { Selects } from './Selects';

interface UserInfoFormProps {
    setstatus: React.Dispatch<React.SetStateAction<number>>;
    title: string;
    metaInfo: MetaInfo[];
    disabledStart: boolean;
    handleMetaInfo: (i: number, value: string) => void;
    headers: boolean;
    status: number;
    handleValidaSesion: () => Promise<boolean>;
    validaPorToken?: boolean;
    TokenExtraInfo: TokenExtraInfo[];
    handleObtenerSelect: (nEncuesta: number, nEncuestaMetaInfo: number, nRespuestaMetaInfoDepende: number | null) => Promise<SelectType[] | undefined>;
}

const UserInfoForm = ({ setstatus, title, metaInfo, handleMetaInfo, disabledStart, headers, status, handleValidaSesion, validaPorToken, TokenExtraInfo, handleObtenerSelect }: UserInfoFormProps) => {
    const xs = useMediaQuery('(min-width: 540px)');
    const isTouchDevice = xs && getIsTouchDevice();

    const metaInfoTextField = _.filter(metaInfo, (o) => o.nTipo === 1 || o.nTipo === 3);
    const metaInfoFiltered = _.filter(metaInfo, (o) => o.nTipo === 2 && o.nPregunta === 0);
    const metaInfoCombos = _.filter(metaInfo, (o) => o.nTipo === 4);

    return (
        <SurveyLayout>
            {/* {metaInfoTextField.length > 0 || metaInfoCombos.length > 0 ? (
                <div className="py-4 pb-[5%]">
                    <strong className={isTouchDevice ? 'text-2xl' : 'text-lg'}>{title}</strong>
                </div>
                ) : null} */}
            {
                TokenExtraInfo.length > 0 && TokenExtraInfo.map((info, i) => {
                    if (info.nTipo === 1){
                        return (
                            <strong className={isTouchDevice ? 'text-2xl' : 'text-lg'} key={i}>Hola {info.cValor}</strong>
                        )
                    }
                })
            }
            <div className="py-4 pb-[5%]">
                <strong className={isTouchDevice ? 'text-2xl' : 'text-lg'}>{title}</strong>
            </div>

            {metaInfo.map((item, i) => {
                const error = item.cValor ? item.cValor.length > 300 : false;
                let valorDepende = null;
                if (item.nEncuestaMetaInfoDepende) {
                    metaInfo.forEach((meta) => {
                        if (meta.nEncuestaMetaInfo === item.nEncuestaMetaInfoDepende) {
                            valorDepende = meta.cValor ?? null;
                        }
                    });
                }
                if (item.nTipo === 1 || item.nTipo === 3) {
                    return (
                        <div key={i} className="pb-5">
                            <Input
                                label={item.cNombreMetaInfo}
                                labelPlacement="outside"
                                variant="underlined"
                                value={item.cValor ?? ''}
                                onValueChange={(value) => handleMetaInfo(i, value)}
                                isInvalid={error}
                                errorMessage={error ? 'Excede los 300 caracteres.' : undefined}
                                classNames={{
                                    input: isTouchDevice ? 'text-2xl' : '',
                                }}
                            />
                        </div>
                    );
                } else if (item.nTipo === 2 && !item.nPregunta) {
                    return (
                        <div key={`desc ${i}`} className="pb-5">
                            <strong className={isTouchDevice ? 'text-2xl' : 'text-lg'}>{item.cNombreMetaInfo}</strong>
                        </div>
                    );
                } else if (item.nTipo === 4) {
                    return (
                        <Selects
                            key={`Select ${i}`}
                            select={item}
                            index={i}
                            validaPorToken={validaPorToken}
                            metaInfo={metaInfo}
                            handleMetaInfo={handleMetaInfo}
                            metaInfoDepende={valorDepende}
                            handleObtenerSelect={handleObtenerSelect}
                        />
                    );
                } else {
                    return <Fragment key={i} />;
                }
            })}

            {metaInfoFiltered.map((item, i) => (
                <strong key={i} className={isTouchDevice ? 'text-2xl' : 'text-lg'}>
                    {item.cNombreMetaInfo}
                </strong>
            ))}

            {metaInfoFiltered.length > 0 && (
                <div className="flex flex-1 items-center justify-center py-5">
                    <IconSurvey width="250px" height="250px" />
                </div>
            )}

            <div
                className={`flex h-37.5 items-center pt-5 ${validaPorToken ? 'justify-end' : 'justify-between'}`}
            >
                {!validaPorToken && (
                    headers ? (
                        <MainMenuBackButton />
                    ) : (
                        <Button
                            variant="flat"
                            onPress={() => setstatus(-1)}
                            className="bg-[#597e6e] text-white shadow-md hover:bg-[#678778]"
                        >
                            REGRESAR
                        </Button>
                    )
                )}

                <Button
                    isDisabled={disabledStart && (metaInfoTextField.length > 0 || metaInfoCombos.length > 0)}
                    onPress={() => {
                        if (!validaPorToken) {
                            handleValidaSesion();
                        }
                        setstatus(status);
                    }}
                    color='success'
                    variant='flat'
                    className={`
                        shadow-md
                        ${isTouchDevice ? 'text-xl' : 'text-sm'}`}
                >
                    {headers ? 'INICIAR ENCUESTA' : 'SIGUIENTE'}
                </Button>
            </div>
        </SurveyLayout>
    );
};

// ${disabledStart && metaInfoTextField.length > 0 ? 'bg-[#E0E0E0]' : 'bg-[#597e6e]'}
export default UserInfoForm;
